import { API_ROUTE_ADMIN_EMPLOYEE_CONSENT_DETAILS } from '@/resources/api-routes'
import { get } from '@/util/auth'

type OriginalEmployeeConsentDetails = {
  id: number
  customerId: number
  title: string
  text: string
  createdDate: string
  employeeConsentStatusId: number
  updated: string | null
  updatedById: string | null
  eligibleCostObjects: {
    id: number
    name: string
    employeeNo: string
    code: string
    department: string
    email: string
    hasApproved: boolean
    approvedDate: string | null
    hasRevoked: boolean
    revokedDate: string | null
  }[]
}

const IS_NEW_BACKEND_API = true

export async function getConsentDetails(consentId: number) {
  return get<OriginalEmployeeConsentDetails>(
    API_ROUTE_ADMIN_EMPLOYEE_CONSENT_DETAILS.replace(':consentId', String(consentId)),
    IS_NEW_BACKEND_API
  )
}
